'use strict';

bbw.model.Geo = ngtk.model.Base.extend({

    _data: null,

    _injectSeparators: false,

    _initialize: function() {
        this._data = {
            geoip: {},
            countries: [],
            regions: [],
            cities: [],
            selected: {},
            loading: {}
        };
    },

    setInjectSeparators: function(doInject) {
        this._injectSeparators = angular.isUndefined(doInject) ? true : !!doInject;
        return this;
    },

    setSelected: function(src) {
        if (angular.isObject(src)) {
            src.country_id && this.selectCountry(src.country_id);
            src.region_id && this.selectRegion(src.region_id);
            src.city_id && this.selectCity(src.city_id);
        }
        return this;
    },

    selectCountry: function(id) {
        this._data.selected.country_id = id;
        return this;
    },

    selectRegion: function(id) {
        this._data.selected.region_id = id;
        return this;
    },

    selectCity: function(id) {
        this._data.selected.city_id = id;
        return this;
    },

    getSelected: function() {
        return this._data.selected;
    },

    loadGeoIp: function() {
        return this._loadFromApi('get', 'geo/ip').then(this._onLoaded.bind(this, 'geoip'));
    },

    loadAll: function() {
        return this.$q.all(
            [
                this.loadCountries(),
                this.loadRegions(),
                this.loadCities()
            ]
        );
    },

    loadByGeoIp: function() {
        return this.$q.all(
            [
                this.loadCountries(),
                this.loadGeoIp().then(function() {
                    var geoip = this._data.geoip;

                    try {
                        this.selectCountry(geoip.country.id);
                        this.selectRegion(geoip.region.id);
                        this.selectCity(geoip.city.id);
                    } catch (e) {
                        // pass
                    }
                    return this.$q.all(
                        [
                            this.loadRegions(),
                            this.loadCities()
                        ]
                    );
                }.bind(this))
            ]
        );
    },

    loadCountries: function() {
        this._data.loading.countries = true;
        return this._loadFromApi('get', 'geo/countries').then(this._onLoadedArray.bind(this, 'countries')).finally(function() {
            delete this._data.loading.countries;
        }.bind(this)).catch(this._onLoadErrorArray.bind(this, 'countries'));
    },

    loadRegions: function(countryId) {
        countryId = countryId || this.getSelected().country_id;
        if (!countryId) {
            return this.$q.when();
        }
        this._data.loading.regions = true;
        return this._loadFromApi('get', 'geo/regions/' + countryId).then(this._onLoadedArray.bind(this, 'regions')).finally(function() {
            delete this._data.loading.regions;
        }.bind(this)).catch(this._onLoadErrorArray.bind(this, 'regions'));
    },

    resetCities: function() {
        ngtk.tools.array.replace(this._data.cities, []);
    },

    loadCities: function(regionId) {
        regionId = regionId || this.getSelected().region_id;
        if (!regionId) {
            return this.$q.when();
        }
        this._data.loading.cities = true;
        return this._loadFromApi('get', 'geo/cities/' + regionId).
            then(this._onLoadedArray.bind(this, 'cities')).
            finally(function() {
                delete this._data.loading.cities;
            }.bind(this)).catch(this._onLoadErrorArray.bind(this, 'cities'))
    },

    get: function() {
        return this._data;
    },

    getCountries: function() {
        return this._data.countries;
    },

    getRegions: function() {
        return this._data.regions;
    },

    getCities: function() {
        return this._data.cities;
    },

    _onLoaded: function(key, result) {
        if (!angular.isObject(result)) {
            result = {};
        }
        ngtk.tools.object.replace(this._data[key], result);
    },

    _onLoadErrorArray: function(key) {
        ngtk.tools.array.replace(this._data[key], []);
    },

    _onLoadedArray: function(key, result) {
        if (!angular.isArray(result)) {
            result = [];
        }
        ngtk.tools.array.replace(this._data[key], result);
        if (this._injectSeparators) {
            this._injectSeparatorsInto(this._data[key]);
        }
    },

    _injectSeparatorsInto: function(dest) {
        var prev_size = -1, injection_place = undefined;
        for (var i = 0; i < dest.length - 1; ++i) {
            var elm = dest[i];
            if (elm.size == 0) {
                if (prev_size > 0) {
                    injection_place = i;
                }
                break;
            }
            prev_size = elm.size;
        }
        if (injection_place) {
            dest.splice(injection_place, 0, {separator: true});
        }
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._data;
    }

});